export * from './simple-slider'
export * from './styles'
